import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import SettingsFilterComponent from "../../JobModuleComponent/FilterComponent/SettingsFilterComponent";

function SettingsAuthTab() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get active tab from URL
  const activeTabFromURL = location.pathname.split("/").pop() || "organizations";
  const [activeTab, setActiveTab] = useState(activeTabFromURL);

  const tabItems = [
    { label: "Organizations", key: "organizations" },
    { label: "Users", key: "users" },
  ];

  return (
    <div className="d-flex align-items-center justify-content-between px-4">
      <div className="d-flex">
        {tabItems.map((tab) => (
          <div
            key={tab.key}
            className={`tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => {
              setActiveTab(tab.key);
              navigate(tab.key);
            }}>
            <b> {tab.label}</b>
          </div>
        ))}
      </div>

      <div className="d-flex align-items-center gap-3">
        <SettingsFilterComponent tab={activeTab} />
      </div>
    </div>
  );
}

export default SettingsAuthTab;
